"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gatherBy = void 0;
function gatherBy(values, pathOrFn, gatherFn) {
    const genKey = typeof pathOrFn === "function"
        ? pathOrFn
        : (element) => {
            if (typeof pathOrFn === "string" || typeof pathOrFn === "number")
                return element[pathOrFn];
            return pathOrFn.reduce((cur, key) => {
                if (!cur || typeof cur !== "object")
                    return undefined;
                return cur[key];
            }, element);
        };
    return values.reduce((gathering, element) => {
        const key = genKey(element);
        gatherFn(gathering, key, element);
        return gathering;
    }, {});
}
exports.gatherBy = gatherBy;
//# sourceMappingURL=gatherBy.js.map